<template>
  <div class="error-wrapper">
    <img :alt="title" :src="imageSource" class="error-image" />
    <h1 class="error-title">{{ title }}</h1>
    <p class="error-desc">
      {{ description }}
      <slot></slot>
    </p>
  </div>
</template>

<script>
export default {
  name: 'ErrorMessage',
  props: {
    title: {
      type: String,
      required: true
    },
    description: {
      type: String,
      required: true
    },
    imageSource: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
.error-wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  padding: 2rem;
  box-sizing: border-box;
}

.error-image {
  max-width: 600px;
  width: 100%;
  height: auto;
  aspect-ratio: 1/1;
  margin-bottom: 1.5rem;
}

.error-title {
  margin-bottom: 1rem;
  text-align: center;
}

.error-desc {
  max-width: 600px;
  text-align: center;
  line-height: 1.5;
}

@media (max-height: 600px) {
  .error-wrapper {
    padding: 1rem;
  }

  .error-image {
    margin-bottom: 0.5rem;
  }

  .error-title {
    margin-bottom: 0.5rem;
    font-size: 1.5rem;
  }

  .error-desc {
    font-size: 0.9rem;
  }
}
</style>
